import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate, group } from '@angular/animations';
import { SessionData } from 'src/app/shared/localstorage/sessionData';
import { SearchInspectionScheduleService } from 'src/app/services/search-inspection-schedule.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('toggleBox', [
      // ...
      state('open', style({
        height: '*',
      })),
      state('closed', style({
        height: '0px',
      })),
      transition('open => closed', [
        animate('.3s')
      ]),
      transition('closed => open', [
        animate('.3s')
      ]),
    ])
  ]
})

export class MenuComponent implements OnInit {

  // Mostrar / Ocultar información
  isOpen = true;
  isOpenNewInspections = true;
  isOpenAdmin = true;
  isOtherOpenAdmin = true;
  isAdmin = false;

  openSub() {
    this.isOpen = !this.isOpen;
  }

  openNewInspections() {
    this.isOpenNewInspections = !this.isOpenNewInspections;
  }

  goToInspectionScheduller() {
    this.searchInspectionScheduleService.setMode("");
    this.searchInspectionScheduleService.setEvent("");
    this.searchInspectionScheduleService.fillFrequeciesList([]);
  }

  openSubAdmin() {
    this.isOpenAdmin = !this.isOpenAdmin;
  }

  openOtherAdmin() {
    this.isOtherOpenAdmin = !this.isOtherOpenAdmin;
  }

  constructor(private searchInspectionScheduleService: SearchInspectionScheduleService) { }

  ngOnInit(): void {
    this.isAdmin = SessionData.getCurrentUser().admin;
  }

}
